// #region Dependencias
import ReactDOMServer from 'react-dom/server'
import { useDispatch, useSelector } from 'react-redux'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2/dist/sweetalert2'
import { setDialogoAbierto } from 'store/slices/uiSlice'
import { IconCancel, IconConfirm, IconInfo } from 'components/Icons'
import { useTranslation } from 'react-i18next'
import { Form, Input, Text } from 'components/Library'
import { validarCorreo, validarNombre, validarTelefono } from 'utils/validations/formValidations'
// #endregion

// #region Estilos
const IconStyle = {
  alignItems: 'center',
  color: 'white',
  display: 'flex',
  height: '2.5rem',
  justifyContent: 'center',
  width: '2.5rem'
}
// #endregion

const FormPago = ({ color, mensaje, nombre, telefono }) => {
  return (
    <>
      <Text style={{ marginBottom: '1rem' }}>{mensaje}</Text>
      <Form
        style={{
          margin: '0 auto',
          maxWidth: '350px'
        }}
      >
        <Input color={color} id="correoPago" type="email" name="correo" label={nombre} />
        <Input color={color} id="telefonoPago" type="tel" name="telefono" label={telefono} />
      </Form>
    </>
  )
}

const FormDatos = ({ color, mensaje, nombre, correo, telefono }) => {
  return (
    <>
      <Text style={{ marginBottom: '1rem' }}>{mensaje}</Text>
      <Form
        style={{
          margin: '0 auto',
          maxWidth: '350px'
        }}
      >
        <Input color={color} id="nombre" name="nombre" label={nombre} />
        <Input color={color} id="telefono" type="tel" name="telefono" label={telefono} />
        <Input color={color} id="correo" type="email" name="correo" label={correo} />
      </Form>
    </>
  )
}

const DialogSwal = withReactContent(Swal)
/**
 * Componente que renderiza un diálogo utilizando la librería SweetAlert2.
 * @class
 * @param {Object} props - Propiedades del componente.
 * @param {string} props.borderradius - Radio de las esquinas de los elementos del componente.
 * @param {Object} props.colores - Objeto de colores para los elementos del componente.
 */
const Dialog = ({ borderradius, color }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { dialogoAbierto, tipo, titulo, mensaje, callback } = useSelector((state) => state.ui)

  // Renderiza el icono correspondiente según el valor de la prop "icon"
  const iconHtml =
    tipo === 'success'
      ? (
      <IconConfirm style={IconStyle} />
        )
      : tipo === 'error'
        ? (
      <IconCancel style={IconStyle} />
          )
        : (
      <IconInfo style={IconStyle} />
          )

  // Muestra el dialogo si la variable: 'dialogoAbierto' es verdadera.
  if (dialogoAbierto) {
    DialogSwal.fire({
      title: titulo,
      text: mensaje,
      input: tipo === 'email' ? 'correo' : tipo === 'payment' ? 'payment' : '',
      inputAutoFocus: true,
      html:
        (tipo === 'email' &&
          ReactDOMServer.renderToString(
            <FormDatos
              color={color}
              mensaje={mensaje}
              nombre={t('name')}
              telefono={t('phone')}
              correo={t('email')}
            />
          )) ||
        (tipo === 'payment' &&
          ReactDOMServer.renderToString(
            <FormPago color={color} mensaje={mensaje} nombre={t('name')} telefono={t('phone')} />
          )),
      cancelButtonText: t('cancel'),
      confirmButtonText: tipo === 'info' ? t('continue') : t('accept'),
      allowOutsideClick: false,
      showCancelButton: tipo !== 'info',
      confirmButtonColor: color,
      iconHtml: ReactDOMServer.renderToString(iconHtml),
      cancelButtonColor: '#000000',
      validationMessage: t('pages.invalid-email'),
      preConfirm:
        tipo === 'email'
          ? () => ({
              nombre: document.getElementById('nombre').value,
              correo: document.getElementById('correo').value,
              telefono: document.getElementById('telefono').value
            })
          : tipo === 'payment'
            ? () => ({
                correo: document.getElementById('correoPago').value,
                telefono: document.getElementById('telefonoPago').value
              })
            : null,
      inputValidator:
        tipo === 'email'
          ? () => {
              const datos = {
                nombre: document.getElementById('nombre').value,
                telefono: document.getElementById('telefono').value,
                correo: document.getElementById('correo').value
              }

              return (
                validarNombre(datos.nombre, t('pages.invalid-name')) ||
                validarTelefono(datos.telefono, t('pages.invalid-phone')) ||
                validarCorreo(datos.correo, t('pages.invalid-email'))
              )
            }
          : tipo === 'payment'
            ? () => {
                const datos = {
                  correo: document.getElementById('correoPago').value,
                  telefono: document.getElementById('telefonoPago').value
                }

                return (
                  validarCorreo(datos.correo, t('pages.invalid-email')) ||
                validarTelefono(datos.telefono, t('pages.invalid-phone'))
                )
              }
            : null,
      customClass: {
        container: 'alert-backdrop',
        popup: 'alert-popup',
        title: 'alert-title',
        icon: 'alert-icon',
        input: 'alert-input',
        htmlContainer: 'alert-text',
        cancelButton: 'alert-button',
        confirmButton: 'alert-button'
      }
    }).then((result) => {
      console.log(result)
      const { isConfirmed, value } = result

      dispatch(
        setDialogoAbierto({
          abierto: false
        })
      )

      if (isConfirmed && callback) callback(value)
      if (isConfirmed && callback) console.log(value)
      else {
        dispatch(
          setDialogoAbierto({
            abierto: false
          })
        )
      }
    })
  }

  // Establece los estilos de color y border-radius de forma dinámica modificando las variables css
  document.documentElement.style.setProperty('--color-primario', color)
  document.documentElement.style.setProperty('--border-radius', `${borderradius}rem`)
}

export default Dialog
